export default __webpack_public_path__ + "static/media/dynamicBlazeReflect.3e0c76ff.jpg";